import { jsx as _jsx } from "react/jsx-runtime";
import { Toggle } from 'frontend/js/modules/infra/dls/components/toggle';
import { t } from 'frontend/js/modules/infra/i18n';
import { useApiMutation } from 'frontend/js/modules/infra/api';
import { showNotification } from 'frontend/js/app/common/helpers/notifications';
import { getViewerIdAndKind, useSession } from 'frontend/js/modules/infra/session';
import styles from '../styles.module.scss';
import { endpoints } from '../../../../network';
export var ToggleColumn = function (_a) {
    var isEnabled = _a.isEnabled, campaignId = _a.campaignId, campaignName = _a.campaignName, subtype = _a.subtype;
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var _b = useApiMutation({
        endpoint: endpoints.reactivateAutomatedCampaignMutation,
        options: {
            onSuccess: function (campaign) {
                showNotification({
                    title: '',
                    message: campaign.isEnabled
                        ? t('engage:automated.campaign_now_active', { campaignName: campaignName })
                        : t('engage:automated.campaign_now_inactive', { campaignName: campaignName }),
                    autoDismiss: 8,
                });
            },
        },
    }), reactivateAutomatedCampaign = _b.mutate, isLoading = _b.isLoading;
    var handleToggle = function (newChecked) {
        reactivateAutomatedCampaign({
            isEnabled: newChecked,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            subtype: subtype,
        });
    };
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _jsx("div", { className: styles['toggle-column-wrapper'], onClick: function (e) {
            e.stopPropagation();
        }, children: _jsx(Toggle, { id: "automated-toggle-".concat(campaignId), disabled: isLoading, checked: isEnabled, onChange: handleToggle, className: styles.center }) }));
};
